import React, { useState, useEffect } from "react";
import './style.css';
import ScoringModal from "../InfoModals/ScoringModal";
import { InfoIcon } from "../../assets/icons/icons";



export default function WellnessScoreContainer({overallScore, maxScore, gradeLetter}) {
    const [isModalOpen, setIsModalOpen] = useState(false);
      
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <div className="wellness-score-container">
            <div className="score-container">
                <div className="score-title-container">
                    <p className="action-subtitle">Overall Wellness Score <InfoIcon className='grade-info-icon' onClick={toggleModal}/></p>
                    <h2 className="action-title-alt">{overallScore} / {maxScore}</h2>
                </div>
                <ScoringModal
                    isOpen={isModalOpen}
                    closeModal={toggleModal}
                />

                {/* Right Side: Circular Grade */}
                <div className="score-circle-container">
                    <div className="score-outer-circle">
                        <div className="score-inner-circle">{gradeLetter}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
